// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-login-component .wm-login-header {
  color: #000;
}
wm-login-component .wm-login-form {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
wm-login-component .wm-login-form .wm-login-label {
  font-size: var(--wm-font-sm);
  font-weight: var(--wm-font-weight-bold);
}
wm-login-component .wm-login-form .wm-login-field-container {
  margin-bottom: 15px;
}
wm-login-component .wm-login-form .wm-login-field-container .wm-login-field {
  --padding-start: 0;
}
wm-login-component .wm-login-form .wm-login-field-container .wm-login-field .wm-login-input-button {
  font-size: var(--wm-font-md);
  --color: var(--wm-color-dark);
  --background: var(--wm-color-light);
  --background-activated: var(--background);
  --background-activated-opacity: 1;
  --background-focused: var(--background);
  --background-focused-opacity: 1;
  --background-hover: var(--background);
  --background-hover-opacity: 1;
}
wm-login-component .wm-login-form .wm-login-field-container .wm-login-field.item-has-focus {
  --border-color: var(--wm-color-secondary);
}
wm-login-component .wm-login-form .wm-login-field-container .wm-login-field.wm-login-field-has-error {
  --border-color: var(--ion-color-danger);
}
wm-login-component .wm-login-form .wm-login-field-container .wm-login-field-error {
  color: var(--ion-color-danger);
  font-size: var(--wm-font-sm);
}
wm-login-component .wm-login-form .wm-login-toggle-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
wm-login-component .wm-login-form .wm-login-toggle-container .wm-login-toggle {
  --background: var(--wm-color-darkgrey);
  --background-checked: var(--wm-color-primary);
  --handle-background: var(--wm-color-light);
  --handle-background-checked: var(--wm-color-light);
  width: 46px;
  height: 24px;
  --handle-width: 20px;
}
wm-login-component .wm-login-form .wm-login-toggle-container .wm-login-toggle-label {
  padding: 0 15px;
  --font-size: var(--wm-font-sm);
  --color: var(--wm-color-darkgrey);
}
wm-login-component .wm-login-buttons-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
  padding-bottom: 60px;
}
wm-login-component .wm-login-buttons-container .wm-login-submit-button,
wm-login-component .wm-login-buttons-container .wm-login-forgot-password-button {
  grid-column-start: 2;
  grid-column-end: 2;
  font-size: var(--wm-font-md);
  padding: 10px;
  margin: 10px;
}
wm-login-component .wm-login-buttons-container .wm-login-submit-button {
  border-radius: 36px;
  border: 1px solid var(--wm-color-primary);
  background: var(--wm-color-primary);
  color: var(--wm-color-light);
}
wm-login-component .wm-login-buttons-container .wm-login-forgot-password-button {
  color: var(--wm-color-darkgrey);
  background: var(--wm-color-light);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/login/login.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AAGE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AADJ;AAEI;EACE,4BAAA;EACA,uCAAA;AAAN;AAEI;EACE,mBAAA;AAAN;AACM;EACE,kBAAA;AACR;AAAQ;EACE,4BAAA;EACA,6BAAA;EACA,mCAAA;EACA,yCAAA;EACA,iCAAA;EACA,uCAAA;EACA,+BAAA;EACA,qCAAA;EACA,6BAAA;AAEV;AACQ;EACE,yCAAA;AACV;AACQ;EACE,uCAAA;AACV;AAEM;EACE,8BAAA;EACA,4BAAA;AAAR;AAGI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AADN;AAGM;EACE,sCAAA;EACA,6CAAA;EACA,0CAAA;EACA,kDAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AADR;AAGM;EACE,eAAA;EACA,8BAAA;EACA,iCAAA;AADR;AAME;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,yBAAA;EACA,oBAAA;AAJJ;AAKI;;EAEE,oBAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;AAHN;AAKI;EACE,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,4BAAA;AAHN;AAKI;EACE,+BAAA;EACA,iCAAA;EACA,0BAAA;AAHN","sourcesContent":["wm-login-component{\n  .wm-login-header {\n    color: #000;\n  }\n\n  .wm-login-form {\n    padding: 15px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    .wm-login-label {\n      font-size: var(--wm-font-sm);\n      font-weight: var(--wm-font-weight-bold);\n    }\n    .wm-login-field-container {\n      margin-bottom: 15px;\n      .wm-login-field {\n        --padding-start: 0;\n        .wm-login-input-button {\n          font-size: var(--wm-font-md);\n          --color: var(--wm-color-dark);\n          --background: var(--wm-color-light);\n          --background-activated: var(--background);\n          --background-activated-opacity: 1;\n          --background-focused: var(--background);\n          --background-focused-opacity: 1;\n          --background-hover: var(--background);\n          --background-hover-opacity: 1;\n        }\n\n        &.item-has-focus {\n          --border-color: var(--wm-color-secondary);\n        }\n        &.wm-login-field-has-error {\n          --border-color: var(--ion-color-danger);\n        }\n      }\n      .wm-login-field-error {\n        color: var(--ion-color-danger);\n        font-size: var(--wm-font-sm);\n      }\n    }\n    .wm-login-toggle-container {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n\n      .wm-login-toggle {\n        --background: var(--wm-color-darkgrey);\n        --background-checked: var(--wm-color-primary);\n        --handle-background: var(--wm-color-light);\n        --handle-background-checked: var(--wm-color-light);\n        width: 46px;\n        height: 24px;\n        --handle-width: 20px;\n      }\n      .wm-login-toggle-label {\n        padding: 0 15px;\n        --font-size: var(--wm-font-sm);\n        --color: var(--wm-color-darkgrey);\n      }\n    }\n  }\n\n  .wm-login-buttons-container {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: flex-end;\n    padding-bottom: 60px;\n    .wm-login-submit-button,\n    .wm-login-forgot-password-button {\n      grid-column-start: 2;\n      grid-column-end: 2;\n      font-size: var(--wm-font-md);\n      padding: 10px;\n      margin: 10px;\n    }\n    .wm-login-submit-button {\n      border-radius: 36px;\n      border: 1px solid var(--wm-color-primary);\n      background: var(--wm-color-primary);\n      color: var(--wm-color-light);\n    }\n    .wm-login-forgot-password-button {\n      color: var(--wm-color-darkgrey);\n      background: var(--wm-color-light);\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
